export default "/_next/static/assets/images/sprite.0e4d1c5657001387693c73998ad25a8e.svg";